import _ from 'lodash';
import queryString from 'query-string';
import {
  validateRequiredArgs,
  validateBrand,
  getFeatureFlags,
  getApiAccessToken,
  getHost,
  getEnvironment
} from 'lib/configUtils';
import {
  WIDGET_REACT_ID,
  WIDGET_MODES,
  BRAND_DOMAINS,
  DEFAULT_OPTIONS,
  TabsType
} from 'config';

import {
  isBrand,
  getHostUrls,
} from "@otrl/ui/lib/utils";

const configureApp = async (mode, scriptArgs = null) => {
  const id = (mode === WIDGET_MODES.IFRAME) ? mode : null;
  const validScriptArgs = _.pick(scriptArgs, Object.keys(DEFAULT_OPTIONS));
  const validQueryStringArgs = _.pick(
    queryString.parse(window.location.search, { parseNumbers: true, parseBooleans: true }),
    Object.keys(DEFAULT_OPTIONS)
  );




  // Build the initial config object
  let appConfig = {
    ...DEFAULT_OPTIONS,
    mode,
    id,
    ...validScriptArgs,
    ...validQueryStringArgs
  };

  const env = getEnvironment(appConfig.brand);
  const { bookingEngine } = getHostUrls(
    appConfig.brand,
    env,
  );

  appConfig.bookingEngineUrl = bookingEngine;

  // Fetch feature flags
  appConfig.featureFlags = getFeatureFlags(scriptArgs);

  validateRequiredArgs(appConfig, ['id', 'apiUrl']);

  // Determine the root element
  appConfig.rootElement = document.getElementById(
    mode === WIDGET_MODES.IFRAME ? WIDGET_REACT_ID : appConfig.id
  );

  // Fetch API access token
  appConfig.apiAccessToken = getApiAccessToken(appConfig.apiUrl);

  // Favourites tab specific config options
  const favouritesTabEnabled = !appConfig.disabledTabs.includes(TabsType.FAVOURITES);
  if (favouritesTabEnabled) {
    validateRequiredArgs(appConfig, ['brand']);
    validateBrand(appConfig.brand);

    // Fetch environment
    appConfig.env = getEnvironment(BRAND_DOMAINS[appConfig.brand]);

    // Fetch host URL
    appConfig.host = getHost(appConfig.brand, appConfig.env);
  }

  return appConfig;
};

export default configureApp;
